module.exports = __webpack_public_path__ + "static/media/ic_28px_Notification_sad_face.277d507b.svg";